var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 262,
    width: 30,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-998 -262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4955 3.02083C8.15903 3.02067 3.02222 8.15722 3.02204 14.4937 3.02186 20.8301 8.15843 25.9669 14.4949 25.9671 20.8313 25.9672 25.9681 20.8307 25.9683 14.4943 25.9683 14.4939 25.9683 14.4934 25.9683 14.4931 25.9706 8.15945 20.8381 3.02316 14.5045 3.02083 14.5015 3.02083 14.4985 3.02083 14.4955 3.02083ZM19.6218 18.1761 18.1776 19.6203 14.4955 15.9376 10.8146 19.6197 9.37032 18.1754 13.05 14.4931 9.36881 10.811 10.8146 9.3667 14.4955 13.05 18.1776 9.3667 19.6218 10.811 15.9397 14.4931Z",
    fill: "#8A2432",
    transform: "matrix(1.03448 0 0 1 998 262)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRejected);
export default __webpack_public_path__ + "static/media/IconRejected.7f9bf267f369a2c8a3630ac493851c47.svg";
export { ForwardRef as ReactComponent };